import jwtDecode from 'jwt-decode'
import _ from 'lodash'

export const Scopes = {
    ACCESS: 'ACCESS',
    OPTIONS_MANAGEMENT: 'OPTIONS_MANAGEMENT',
    USER_MANAGEMENT: 'USER_MANAGEMENT',
    PASSWORD_CHANGE: 'PASSWORD_CHANGE',
}

export const AuthStates = {
    AUTHORIZED: 'AUTHORIZED', // The user is authorized with the required scope and the token is not expired.
    EXPIRED: 'EXPIRED',      // The user's token has expired, regardless of the scope.
    FORBIDDEN: 'FORBIDDEN',  // The user is not authorized with the required scope.
}

/**
 * Get the user's token state based on authorization and expiration.
 * @param {string} token - The user's token.
 * @param {[string]} requiredScopes - The required scope.
 * @returns {string} - The user's token state.
 */
export const getUserTokenState = (token, requiredScopes) => {
    // If no token is provided, the user is not authorized.
    if (_.isEmpty(token)) {
        return AuthStates.FORBIDDEN
    }

    const decodedToken = jwtDecode(token)
    const tokenScopes = decodedToken.scopes || []
  
    const isAuthorized = requiredScopes.every(scope => tokenScopes.includes(scope))
    const isExpired = decodedToken.exp <= Date.now() / 1000 

    // The token has the required scope and is not expired.
    if (isAuthorized && !isExpired) {
        return AuthStates.AUTHORIZED
    }

    // The token is not expired, but does not have the required scope.
    if (!isAuthorized) {
        return AuthStates.FORBIDDEN
    }

    // The token has the required scope, but it is expired.
    return AuthStates.EXPIRED
}


